module.exports = __webpack_public_path__ + "static/media/WALLETS.2d2cf75d.png";